import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=f6fc2d6c&scoped=true"
import script from "./saleDetail.vue?vue&type=script&lang=js"
export * from "./saleDetail.vue?vue&type=script&lang=js"
import style0 from "./saleDetail.vue?vue&type=style&index=0&id=f6fc2d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc2d6c",
  null
  
)

export default component.exports